import LayoutPasos from "_+_Portal/_-_Autocheckin/components/genericos/LayoutPasos/LayoutPasos";
import { PortalContext } from "_+_Portal/context/Provider";
import { GlobalContext } from "global/context/Provider";
import camelize from "global/utils/camelize";
import { useContext, useEffect, useState } from "react";
import { OrderTurnosLabo } from "../PagesFun";
import { wsGetTurnosPacienteDelDiaQr } from "_+_Portal/_-_Autocheckin/context/action/turnosAutoCheckIn";
import { AutocheckContext } from "_+_Portal/_-_Autocheckin/context/Provider";
import Loading from "_+_Portal/components/Genericos/Loading/Loading";
import { BodyTurnosDeldiaLabo } from "./localStyle";
import CardAusente from "_+_Portal/_-_Autocheckin/components/genericos/CardAusente/CardAusente";
import CardCheck from "_+_Portal/_-_Autocheckin/components/genericos/CardCheck/CardCheck";
import { showToaster } from "global/context/action/toaster/toaster";

import { setPaso } from "_+_Portal/_-_Autocheckin/context/action/paso";
import { setIdTipoPuntoControl } from "_+_Portal/_-_Autocheckin/context/action/puntoControl";
import { setTurnosSeleccionado } from "_+_Portal/_-_Autocheckin/context/action/turnosSeleccionados";
import { showModal } from "global/context/action/modal/modal";
import ModalAutoT from "_+_Portal/_-_Autocheckin/components/genericos/ModalAutoT/ModalAutoT";
import { hideModal } from "_+_Portal/context/Actions/modal/modal";

const TurnosDelDiaLabo = () => {
  //#region --------- context ---------------
  const { selectDropDownState } = useContext(PortalContext);
  const {
    turnosAutoCheckInDispatch,
    pasoDispatch,
    textosAutoCheckinState,
    puntoControlDispatch,
    turnosSeleccionadosDispatch,
  } = useContext(AutocheckContext);
  const { authState, toasterDispatch, modalDispatch } =
    useContext(GlobalContext);
  //#endregion  ----- context ---------------
  //#region  ----------- constants ---------------
  const [loading, setLoading] = useState(true);
  const [turnos, setTurnos] = useState([]);
  const pacienteNombre = selectDropDownState.selectDropDown.selectGlobal
    .pacienteElegido?.paciente?.nombre
    ? selectDropDownState.selectDropDown.selectGlobal.pacienteElegido?.paciente
        ?.nombre
    : authState.auth.data.paciente.nombre;
  const idPacFamiliar = selectDropDownState.selectDropDown.selectGlobal
    .pacienteElegido?.paciente?.codigo
    ? selectDropDownState.selectDropDown.selectGlobal.pacienteElegido?.paciente
        ?.codigo
    : false;
  let config = localStorage.getItem("config");
  let filtroHorario =
    textosAutoCheckinState.textosAutoCheckin?.data?.filtroHorario?.orden;
  let minutosToleranciaRecepcion =
    JSON.parse(config)?.minutosToleranciaRecepcion;
  let minRecepcionVariosTurnos = JSON.parse(config)?.minRecepcionVariosTurnos;
  //#endregion --------- constants ---------------

  //#region  ----------- funciones ---------------
  const handleVolver = () => {
    setPaso("Home")(pasoDispatch);
  };
  const handleSeleccionar = (id, isSelected) => {
    let newTurnos = turnos.map((turno) => {
      if (turno.idProtocolo === id) {
        if (turno.type !== "fueraRangoHorario") {
          turno.selected = isSelected;
          return turno;
        }
      }
      return turno;
    });
    setTurnos(newTurnos);
  };

  const handleClick = () => {
    const turnosDisponibles = turnos.filter(
      (turno) => turno.type !== "ausente" && turno.type !== "fueraRangoHorario"
    );

    const protocolosConfirmados = turnos.filter(
      (turno) =>
        turno.estadoProtocolo > 1 &&
        turno.estadoProtocolo < 4 &&
        turno.type === "laboratorio" &&
        turno.selected
    );

    const turnosNoConfirmados = turnos.filter((turno) => {
      return turno.estadoProtocolo === 1 && turno.type === "laboratorio";
    });

    if (turnosNoConfirmados.length > 0) {
      // const idTipoPuntoControl = 15;
      // setIdTipoPuntoControl(idTipoPuntoControl)(puntoControlDispatch);
      setPaso("EstudiosLabo")(pasoDispatch);
    } else {
      if (protocolosConfirmados.length > 0) {
        setTurnosSeleccionado(protocolosConfirmados)(
          turnosSeleccionadosDispatch
        );
        if (protocolosConfirmados.length < turnosDisponibles.length) {
          showModal(
            <ModalAutoT
              dissmiss={dismiss}
              desc={
                "Te falta seleccionar algún turno. ¿Querés avanzar con la recepción de tus otros turnos?"
              }
              title={"Recepción"}
              textBtnOne={"SI"}
              textBtnTwo={"NO"}
              handleChange={{
                btnOne: () => {
                  dismiss();
                  setPaso("UbicacionActual")(pasoDispatch);
                },
                btnTwo: () => {
                  dismiss();
                },
              }}
            />,
            "Información",
            dismiss,
            false,
            {},
            "centro",
            true
          )(modalDispatch);
        } else {
          // setPaso("UbicacionActual")(pasoDispatch);
          setPaso("NumeroAfiliado")(pasoDispatch);
        }
      } else {
        showToaster(
          {
            texto: "Debe seleccionar al menos un turno.",
            tipo: "danger",
          },
          "centroArriba"
        )(toasterDispatch);
      }
    }
  };
  const dismiss = () => {
    hideModal()(modalDispatch);
  };
  //#endregion --------- funciones ---------------

  //#region  ----------- useEffect ---------------
  useEffect(() => {
    const nextStepTurnosList = (isCorrect, data) => {
      if (isCorrect) {
        const turnosOrdenados = OrderTurnosLabo(
          data,
          filtroHorario,
          minutosToleranciaRecepcion,
          minRecepcionVariosTurnos
        );
        const osValidacionInterna = turnosOrdenados.filter(
          (turno) => turno.type === "osValidacionInterna"
        );
        const noPermiteCheckIn = turnosOrdenados.filter(
          (turno) => turno.type === "noPermiteCheckIn"
        );
        if (osValidacionInterna.length > 0) {
          setTurnosSeleccionado(osValidacionInterna)(
            turnosSeleccionadosDispatch
          );
          const idTipoPuntoControl = 13;
          setIdTipoPuntoControl(idTipoPuntoControl)(puntoControlDispatch);
          setPaso("PuntoControl")(pasoDispatch);
        } else if (noPermiteCheckIn.length > 0) {
          setTurnosSeleccionado(noPermiteCheckIn)(turnosSeleccionadosDispatch);
          const idTipoPuntoControl = 1;
          setIdTipoPuntoControl(idTipoPuntoControl)(puntoControlDispatch);
          setPaso("PuntoControl")(pasoDispatch);
        } else {
          setLoading(false);
          const protocolosConfirmadosYSinConfirmar = turnosOrdenados.filter(
            (turno) =>
              turno.estadoProtocolo >= 1 &&
              turno.estadoProtocolo < 4 &&
              turno.type === "laboratorio" &&
              turno.selected
          );
          setTurnos(protocolosConfirmadosYSinConfirmar);
        }
      }
    };
    if (loading) {
      wsGetTurnosPacienteDelDiaQr(nextStepTurnosList)(
        turnosAutoCheckInDispatch
      );
    }
  }, []);
  //#endregion  -------- useEffect ---------------

  return (
    <>
      {loading ? (
        <Loading
          dataLoading={loading}
          color="c-white"
          descripcion={"Cargando..."}
        />
      ) : (
        <LayoutPasos
          handleClick={handleVolver}
          title={camelize(pacienteNombre)}
          subtitle={"¿En qué podemos ayudarte hoy?"}
        >
          <BodyTurnosDeldiaLabo
            initial={{ opacity: 0, y: -50 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 100 }}
            transition={{ duration: 0.4 }}
          >
            {turnos.map((element, key) => {
              if (element?.type === "ausente") {
                return (
                  <CardAusente
                    title={element.especialidad}
                    horario={element.hora}
                    sede={element.centro}
                    medico={element.medico}
                    key={key}
                    setTurnos={setTurnos}
                    turnos={turnos}
                    id={element.idturno}
                    actived={element.selected}
                    flgSoloConsulta={element.flgSoloConsulta}
                  />
                );
              }
              return (
                <CardCheck
                  title={element.especialidad}
                  horario={element.hora}
                  sede={element.centro}
                  medico={element.medico}
                  key={key}
                  setTurnos={setTurnos}
                  turnos={turnos}
                  id={element.idturno}
                  actived={element.selected}
                  flgSoloConsulta={element.flgSoloConsulta}
                  setSelected={(isSelected) =>
                    handleSeleccionar(element.idProtocolo, isSelected)
                  }
                />
              );
            })}

            {loading || turnos.length === 0 ? (
              ""
            ) : (
              <button onClick={handleClick}>
                Recepcionar turnos de laboratorio
              </button>
            )}
            {turnos.length === 0 && !loading ? (
              <h1 className="title">No hay turnos de laboratorio</h1>
            ) : (
              ""
            )}
          </BodyTurnosDeldiaLabo>
        </LayoutPasos>
      )}
    </>
  );
};

export default TurnosDelDiaLabo;
